import { render, staticRenderFns } from "./clHowToGet.vue?vue&type=template&id=0ec7cfb9&scoped=true"
import script from "./clHowToGet.vue?vue&type=script&lang=js"
export * from "./clHowToGet.vue?vue&type=script&lang=js"
import style0 from "./clHowToGet.vue?vue&type=style&index=0&id=0ec7cfb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7cfb9",
  null
  
)

export default component.exports